<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { DilWeb } from "../../../../path";

export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    // Default to last 7 days
    const today = new Date();
    const prior = new Date();
    prior.setDate(prior.getDate() - 7);

    return {
      title: "Partner form and Enquires",
      items: [{ text: "DilLeads" }, { text: "Import", active: true }],
      base_node_url: process.env.VUE_APP_API_BACKEND_NODE_URL,
      date_range: [prior, today],
      partnerForms: [],
      partnerMeta: { current_page: 1, per_page: 10, total: 0, last_page: 0 },
      enquiries: [],
      enquireMeta: { current_page: 1, per_page: 10, total: 0, last_page: 0 },
      partnerFields: [
        { key: "name", label: "Name" },
        { key: "restaurantName", label: "Restaurant" },
        { key: "area", label: "area" },
        { key: "city", label: "City" },
        { key: "contactNumber", label: "Contact Number" },
        { key: "email", label: "Email" },
        { key: "created_at", label: "Date" },
      ],
      enquiryFields: [
        { key: "brandName", label: "Brand" },
        { key: "city", label: "City" },
        { key: "contactNumber", label: "Contact Number" },
        { key: "email", label: "Email" },
        { key: "quantities", label: "Quantities" },
        { key: "selectedCategories", label: "Categories" },
        { key: "created_at", label: "Date" },
      ],
    };
  },
  methods: {
    formatForApi(date) {
      return date.toISOString().substr(0, 10);
    },
    applyFilter() {
      this.partnerMeta.current_page = 1;
      this.enquireMeta.current_page = 1;
      this.fetchPartnerForms();
      this.fetchEnquiries();
    },
    fetchPartnerForms() {
      const [startDate, endDate] = this.date_range;
      if (!startDate || !endDate) return;
      const start = this.formatForApi(startDate);
      const end = this.formatForApi(endDate);

      axios
        .get(this.base_node_url + DilWeb.GET_DATA, {
          params: {
            type: "partner_form",
            start,
            end,
            page: this.partnerMeta.current_page,
            per_page: this.partnerMeta.per_page,
          },
        })
        .then((res) => {
          const d = res.data.data;
          this.partnerForms = d.data;
          this.partnerMeta = {
            current_page: d.current_page,
            per_page: d.per_page,
            total: d.total,
            last_page: d.last_page,
          };
        })
        .catch((err) => console.error(err));
    },
    fetchEnquiries() {
      const [startDate, endDate] = this.date_range;
      if (!startDate || !endDate) return;
      const start = this.formatForApi(startDate);
      const end = this.formatForApi(endDate);

      axios
        .get(this.base_node_url + DilWeb.GET_DATA, {
          params: {
            type: "enquire",
            start,
            end,
            page: this.enquireMeta.current_page,
            per_page: this.enquireMeta.per_page,
          },
        })
        .then((res) => {
          const d = res.data.data;
          this.enquiries = d.data;
          this.enquireMeta = {
            current_page: d.current_page,
            per_page: d.per_page,
            total: d.total,
            last_page: d.last_page,
          };
        })
        .catch((err) => console.error(err));
    },
    downloadCsv(type) {
      const [startDate, endDate] = this.date_range;
      if (!startDate || !endDate) return;
      const start = this.formatForApi(startDate);
      const end = this.formatForApi(endDate);
      const url = `${this.base_node_url}${DilWeb.DOWNLOAD}?type=${type}&start=${start}&end=${end}`;
      console.log(url);
      window.open(url, "_blank");
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
  },
  watch: {
    "partnerMeta.current_page": "fetchPartnerForms",
    "enquireMeta.current_page": "fetchEnquiries",
  },
  mounted() {
    this.fetchPartnerForms();
    this.fetchEnquiries();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card mb-4">
      <div class="card-body">
        <b-row class="align-items-center">
          <b-col sm="4">
            <b-form-group>
              <label>Date Range</label>
              <date-picker
                range
                v-model="date_range"
                show-week-number
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col sm="2 mt-3">
            <b-button variant="primary" @click="applyFilter">Apply</b-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-5">
        <div class="card">
          <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">Partner Forms</h5>
            <b-button variant="success" @click="downloadCsv('partner_form')"
              >Download CSV</b-button
            >
          </div>
          <div class="card-body">
            <b-table :items="partnerForms" :fields="partnerFields" hover>
              <template #cell(created_at)="row">
                {{ formatDate(row.item.created_at) }}
              </template>
            </b-table>
            <b-pagination
              v-model="partnerMeta.current_page"
              :total-rows="partnerMeta.total"
              :per-page="partnerMeta.per_page"
              align="right"
            />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">Enquiries</h5>
            <b-button variant="success" @click="downloadCsv('enquire')"
              >Download CSV</b-button
            >
          </div>
          <div class="card-body">
            <b-table :items="enquiries" :fields="enquiryFields" hover>
              <template #cell(selectedCategories)="row">
                <div
                  style="white-space: nowrap; width: max-content"
                  v-for="(cat, i) in row.item.selectedCategories"
                  :key="i"
                >
                  {{ cat }}
                </div>
              </template>
              <template #cell(created_at)="row">
                {{ formatDate(row.item.created_at) }}
              </template>
            </b-table>
            <b-pagination
              v-model="enquireMeta.current_page"
              :total-rows="enquireMeta.total"
              :per-page="enquireMeta.per_page"
              align="right"
            />
          </div>
        </div>
      </div></div
  ></Layout>
</template>
